import React, { FC } from 'react';
import Button, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SlideUpTransition from './transitions/SlideUp';
import other from 'menu-items/other';

interface ButtonProps {
    variant?: MuiButtonProps['variant'];
    children?: MuiButtonProps['children'];
}

interface Props extends DialogProps {
    dialogTitle?: string | JSX.Element;
    content?: string | JSX.Element;
    acceptButtonProps?: ButtonProps;
    cancelButtonProps?: ButtonProps;
    onAccept: () => void;
    onCancel: () => void;
}

const AlertDialog: FC<Props> = (props) => {
    const { dialogTitle, content, acceptButtonProps, cancelButtonProps, onClose, onAccept, onCancel, ...others } = props;

    const handleCancel = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        onClose && onClose(event, 'backdropClick');
        onCancel && onCancel();
    };

    const handleAccept = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        onClose && onClose(event, 'backdropClick');
        onAccept && onAccept();
    };

    const contentId = `alert-dialog-content`;

    return (
        <Dialog {...others} TransitionComponent={SlideUpTransition}>
            {dialogTitle && <DialogTitle>{dialogTitle}</DialogTitle>}
            {content && (
                <DialogContent>
                    <DialogContentText id={contentId}>{content}</DialogContentText>
                </DialogContent>
            )}
            {(!!onAccept || !!onCancel) && (!!cancelButtonProps || !!acceptButtonProps) && (
                <DialogActions>
                    <Button {...cancelButtonProps} onClick={handleCancel} />
                    <Button {...acceptButtonProps} onClick={handleAccept} />
                </DialogActions>
            )}
        </Dialog>
    );
};

export default AlertDialog;
